export default __webpack_public_path__ + "static/media/upperEcllipse.907fb8c0.png";